import styles from './index.module.scss'
import { Segmented } from 'antd';


const SegmentedWarp = (props) => {
    const { optionsList } = props


    return (
        <div className={styles.SegmentedWarp}>
            <Segmented options={optionsList} onChange={value => {
                const index = optionsList.findIndex(option => option.value === value || option === value);
                props.getModelSegmentedValue(index)
            }} block />
        </div>
    )
}


export default SegmentedWarp
